import { MapPin } from "@phosphor-icons/react";
import { Message } from "../../../models/Message";
import { buildLocationMapURL, formatLocationCoordinates, parseLocationMessage } from "../../../utils/specialMessages";
import { LocationView } from "./styles";

export interface LocationProps {
  message: Message;
};

export const Location = ({ message }: LocationProps ) => {
  const location = parseLocationMessage( message );
  const mapURL = buildLocationMapURL( location );
  const title = location?.name || location?.address || location?.comment || "Localização compartilhada";
  const coordinates = formatLocationCoordinates( location );
  const subtitle = location?.address && location?.address !== title ? location.address : coordinates;
  const Card = mapURL ? "a" : "div";

  return (
    <LocationView>
      <Card
        className="location-card"
        href={ mapURL || undefined }
        target={ mapURL ? "_blank" : undefined }
        rel={ mapURL ? "noreferrer" : undefined }
      >
        <div className="location-icon">
          <MapPin
            size={ 28 }
            weight="duotone"
          />
        </div>

        <div className="location-info">
          <strong>{ title }</strong>

          {
            subtitle ? <span>{ subtitle }</span> : <></>
          }
        </div>
      </Card>
    </LocationView>
  );
};
